import { Employee } from "../types/ganttChart";

export type TeamGroupColorMaps = {
  colorGroupCounts: Record<string, number>;
  colorGroupToTeamNumberMap: Map<string, string>;
};

class TeamColorGroupUtils {
  /**
   * Nexus has a concept of "teams" as employees tagged with a particular hex color code. We group employees by hex code and put them into teams accordingly.
   * This is used to show which team (in Pondoo's view) an employee is associated with, and this team-wide color group is used by individual tasks to show
   * an indicator if that task was manually moved in Nexus to a different team.
   * @param employees
   */
  public static computeTeamColorGroupMaps = (
    employees: Employee[],
  ): TeamGroupColorMaps => {
    const colorGroupCounts: Record<string, number> = {};
    const colorGroupToTeamNumberMap = employees.reduce((map, employee) => {
      const { colorGroup } = employee;
      colorGroupCounts[colorGroup] = (colorGroupCounts[colorGroup] ?? 0) + 1;
      if (!map.has(colorGroup)) {
        const teamNumber = map.size + 1;
        map.set(colorGroup, `Team ${teamNumber}`);
      }

      return map;
    }, new Map<string, string>());

    return { colorGroupCounts, colorGroupToTeamNumberMap };
  };
}

export default TeamColorGroupUtils;
